export var getQueryReadiness = function getQueryReadiness(state) {
  return state.app.isQueryReady;
};